var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBluehouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#E5EFFB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_812_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9931 24.8715C34.9931 25.4965 34.4722 25.9861 33.8819 25.9861H32.7708L32.7951 31.5486C32.7951 31.6424 32.7882 31.7361 32.7778 31.8299V32.3889C32.7778 33.1563 32.1562 33.7778 31.3889 33.7778H30.8333C30.7951 33.7778 30.7569 33.7778 30.7187 33.7743C30.6701 33.7778 30.6215 33.7778 30.5729 33.7778H29.4444H28.6111C27.8437 33.7778 27.2222 33.1563 27.2222 32.3889V31.5556V29.3333C27.2222 28.7188 26.7257 28.2222 26.1111 28.2222H23.8889C23.2743 28.2222 22.7778 28.7188 22.7778 29.3333V31.5556V32.3889C22.7778 33.1563 22.1562 33.7778 21.3889 33.7778H20.5556H19.4479C19.3958 33.7778 19.3437 33.7743 19.2917 33.7708C19.25 33.7743 19.2083 33.7778 19.1667 33.7778H18.6111C17.8437 33.7778 17.2222 33.1563 17.2222 32.3889V28.5C17.2222 28.4688 17.2222 28.434 17.2257 28.4028V25.9861H16.1111C15.4861 25.9861 15 25.5 15 24.8715C15 24.559 15.1042 24.2813 15.3472 24.0382L24.25 16.2778C24.4931 16.0347 24.7708 16 25.0139 16C25.2569 16 25.5347 16.0694 25.7431 16.2431L34.6111 24.0382C34.8889 24.2813 35.0278 24.559 34.9931 24.8715Z",
    fill: "#47A7FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_812_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17.7778,
    fill: "white",
    transform: "translate(15 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluehouse);
export default __webpack_public_path__ + "static/media/bluehouse.bab0ee4f79a2d06d8f0e9af2a53b4f2e.svg";
export { ForwardRef as ReactComponent };